import { MarisolFeatureList } from "@/components/MarisolFeatureList/MarisolFeatureList.component";

export default MarisolFeatureList;
